import { render } from "./ThoughtRecord.vue?vue&type=template&id=35efe9c6&scoped=true"
import script from "./ThoughtRecord.vue?vue&type=script&lang=js"
export * from "./ThoughtRecord.vue?vue&type=script&lang=js"

import "./ThoughtRecord.vue?vue&type=style&index=0&id=35efe9c6&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35efe9c6"]])

export default __exports__